import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../../../reducers/types";
import { TravelWalletSelection } from "./component";
import {
  getCreditToApply,
  getFetchApplicableTravelWalletItemsCallState,
  getOffers,
  getOfferToApply,
  getRewardsPaymentAccountReferenceId,
  getSelectedPaymentMethodId,
  getBestOfferOverall,
  getVacationRentalsIsStackedTravelWalletPaymentOnly,
  getVacationRentalsIsTravelWalletCreditPaymentOnly,
  getVacationRentalsIsTravelWalletOfferPaymentOnly,
  getVacationRentalsMaxApplicableTravelWalletCreditAmount,
  getApplicableCredit,
  getApplicableCreditsBreakdown,
  getIneligibleCreditsBreakdown,
} from "../../reducer";
import {
  setOfferToApply,
  setSelectedRewardsPaymentTotal,
  resetPaymentCardSelectedAccounts,
  setCreditToApply,
} from "../../actions/actions";
import {
  getTravelCreditsHistoryTransaction,
  getPartialHistoryValidFromTime,
} from "../../../travel-wallet/reducer";
import { getRewardsAccounts } from "../../../rewards/reducer";

const mapStateToProps = (state: IStoreState) => ({
  offers: getOffers(state),
  offerToApply: getOfferToApply(state),
  fetchApplicableTravelWalletItemsCallState:
    getFetchApplicableTravelWalletItemsCallState(state),
  selectedPaymentMethodId: getSelectedPaymentMethodId(state) ?? "",
  selectedRewardsPaymentAccountId: getRewardsPaymentAccountReferenceId(state),
  credits: getApplicableCredit(state),
  creditBreakdown: getApplicableCreditsBreakdown(state),
  creditsToApply: getCreditToApply(state),
  isStackedTravelWalletPaymentOnly:
    getVacationRentalsIsStackedTravelWalletPaymentOnly(state),
  isTravelCreditPaymentOnly:
    getVacationRentalsIsTravelWalletCreditPaymentOnly(state),
  isTravelWalletOfferPaymentOnly:
    getVacationRentalsIsTravelWalletOfferPaymentOnly(state),
  creditsHistoryTransaction: getTravelCreditsHistoryTransaction(state),
  partialHistoryValidFromTime: getPartialHistoryValidFromTime(state),
  bestOverallOffer: getBestOfferOverall(state),
  rewardsAccounts: getRewardsAccounts(state),
  maxApplicableTravelWalletCredit:
    getVacationRentalsMaxApplicableTravelWalletCreditAmount(state),
  ineligibleCreditsBreakdown: getIneligibleCreditsBreakdown(state),
});

export const mapDispatchToProps = {
  setOfferToApply,
  resetPaymentCardSelectedAccounts,
  setSelectedRewardsPaymentTotal,
  setCreditToApply,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type TravelWalletSelectionConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedTravelWalletSelection = withRouter(
  connector(TravelWalletSelection)
);
